module.exports = __webpack_public_path__ + "static/media/img21.958ed5f9.jpg";